// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React from "react";
import { Link } from "react-router-dom";

import { Volunteer, SchoolDocument, MarkdownDocument } from "../store/schema";
import { URLS } from "../urls";

export function acceptedAllRequiredMarkdowns(
  volunteer: Volunteer,
  school: SchoolDocument | null
): boolean {
  return (
    school != null &&
    !school.data.requiredMarkdowns.some(
      uid =>
        !volunteer.acceptedMarkdowns.some(
          accepted => accepted.markdownUid === uid
        )
    )
  );
}

interface PendingMarkdownsProps {
  volunteer: Volunteer;
  school: SchoolDocument | null;
  markdowns: MarkdownDocument[];
}

export const PendingMarkdowns: React.FC<PendingMarkdownsProps> = props => {
  const { volunteer, school, markdowns } = props;

  if (school == null) {
    return null;
  }

  const pendingUids = school.data.requiredMarkdowns.filter(
    required =>
      !volunteer.acceptedMarkdowns.some(
        accepted => accepted.markdownUid === required
      )
  );
  if (pendingUids.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="section">
        Please read and acknowledge the following{" "}
        {pendingUids.length > 1 ? "documents" : "document"} before you can
        record volunteer activities:
      </div>
      {pendingUids.map(uid => (
        <div className="nav" key={uid}>
          <Link to={URLS.vMarkdown(uid)}>{markdownName(markdowns, uid)}</Link>
        </div>
      ))}
    </div>
  );
};

function markdownName(markdowns: MarkdownDocument[], uid: string) {
  const markdown = markdowns.find(x => x.data.uid === uid);
  return markdown == null ? `Loading '${uid}'..` : markdown.data.name;
}
